import { Branch, createSocketService, PermissionType, convertUnixToDate } from '@golden/gdk-base';
import { pairwise } from 'rxjs';
import { alertInfoMapPermission } from '../constants/alertInfoMapPermission';
var payloadType;
(function (payloadType) {
    payloadType["FINANCE_ALERT"] = "admin.finance.alert";
    payloadType["ME"] = "admin.me";
})(payloadType || (payloadType = {}));
const branch = {
    [payloadType.FINANCE_ALERT]: Branch.ADMIN_FINANCE_ALERT,
    [payloadType.ME]: Branch.ME
};
export function createAdminSocketService(api, socket, trunk, admin, finance, platform, alert, auth, realTime) {
    const socketService = createSocketService('admin/', api, socket);
    socket.on('connect', () => {
        socketService.join('admins');
        realTime.updatePollingTime({
            minuteDenominator: 3,
            secondDenominator: 0
        });
    });
    socket.on('disconnect', () => {
        realTime.updatePollingTime({
            minuteDenominator: 0,
            secondDenominator: 30
        });
    });
    socket.on('withdraw.created', (data) => {
        const hasFmPermission = admin.me.value?.permissions.includes(PermissionType.WITHDRAW_FM_SLIP) ?? false;
        const hasRcPermission = admin.me.value?.permissions.includes(PermissionType.WITHDRAW_RC_SLIP) ?? false;
        if (hasFmPermission || hasRcPermission) {
            finance.alert.next({
                withdraw_ids: (data.type === 'fm' && hasFmPermission) ? data.withdraw_ids : [],
                rc_withdraw_ids: (data.type === 'rc' && hasRcPermission) ? data.withdraw_ids : []
            });
        }
        if (hasFmPermission && data.type === 'fm') {
            admin.me.next({
                ...admin.me.value,
                has_withdraw: true
            });
        }
    });
    socket.on('withdraw.updated', (data) => {
        const hasFmPermission = admin.me.value?.permissions.includes(PermissionType.WITHDRAW_FM_SLIP) ?? false;
        if (hasFmPermission) {
            admin.me.next({
                ...admin.me.value,
                has_withdraw: data.has_withdraw
            });
        }
    });
    socket.on('platforms.updated', (data) => {
        const changedPlatformIds = data.map((game) => game.platform_id);
        const changedGameIds = data.map((game) => game.id);
        const newPlatforms = platform.platforms.value.map((platform) => {
            if (changedPlatformIds.includes(platform.id)) {
                const changedGame = data.find((game) => game.platform_id === platform.id);
                if (changedGame === undefined)
                    return platform;
                const newGames = platform.games.map((game) => {
                    if (changedGameIds.includes(game.id)) {
                        const changedGame = data.find((changed) => changed.id === game.id);
                        if (changedGame === undefined)
                            return game;
                        return {
                            ...game,
                            category: changedGame.category,
                            status: changedGame.status,
                            memo: changedGame.memo
                        };
                    }
                    return game;
                });
                return {
                    ...platform,
                    games: newGames,
                    is_active: changedGame.is_active
                };
            }
            return platform;
        });
        platform.platforms.next(newPlatforms);
    });
    socket.on('not.loginable', () => {
        auth.logout().subscribe();
    });
    socket.on('alert.created', (data) => {
        const hasPermission = (admin.me.value?.permissions.includes(alertInfoMapPermission[data.info]) ?? false);
        if (hasPermission) {
            alert.recentAlerts.next([{
                    ...convertUnixToDate(data, 'created_at')
                }]);
            admin.me.next({
                ...admin.me.value,
                has_alert: true
            });
        }
    });
    socket.on('user.created', () => {
        admin.me.next({
            ...admin.me.value,
            has_newcomer: true
        });
    });
    socket.on('admin.data.changed', (payload) => {
        const nextTrunks = payload
            .map(item => branch[item])
            .filter((b) => !!b); // filter undefined event
        trunk.next(nextTrunks, (error, branches) => socketService.handleError?.(error, branches));
    });
    socket.on('admin.withdraw.balance', () => {
        trunk.next([Branch.ADMIN_WITHDRAW_SLIP_ACCOUNTING], (error, branches) => socketService.handleError?.(error, branches));
    });
    admin.me.pipe(pairwise()).subscribe(([prev, current]) => {
        if (!prev?.account && current?.account) {
            socketService.getToken(`admins.${current.account}`).subscribe(({ token }) => {
                socketService.join(`private-admins.${current.account}`, token);
            });
        }
        if (prev?.account && !current?.account) {
            socketService.leave(`private-admins.${prev.account}`);
        }
    });
    return socketService;
}
//# sourceMappingURL=SocketService.js.map